import { render } from "./fb-new.vue?vue&type=template&id=451afcda&scoped=true"
import script from "./fb-new.vue?vue&type=script&lang=js"
export * from "./fb-new.vue?vue&type=script&lang=js"

import "./fb-new.vue?vue&type=style&index=0&id=451afcda&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451afcda"]])

export default __exports__